import { AuthService } from './core/auth/auth.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export function appInitializer(): Promise<void> | void {
  const authService = inject(AuthService);

  if (!authService.token) {
    authService.resetSession();
    return;
  }

  return firstValueFrom(authService.me())
    .then(() => undefined)
    .catch(() => {
      authService.resetSession();
    });
}
